/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsSlideshowClassic = {
	init: function($section) {

    // Add settings from schema to current object
    Shopify.theme.jsSlideshowClassic = $.extend(this, Shopify.theme.getSectionData($section));

    // Selectors
    const $slideshowClassicEl = $section.find('[data-slideshow-classic]').removeClass('is-hidden');

    const $slideshowClassic = $slideshowClassicEl.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: this.number_of_slides > 1 ? this.show_arrows : false,
      pageDots: this.number_of_slides > 1 ? this.show_nav_buttons : false,
      draggable: true,
      imagesLoaded: true,
      fade: this.image_transition == 'fade' ? true : false,
      // ADA (WCAG 2.2.2 Pause, Stop, Hide): autoplay is enabled but made
      // pausable — Flickity pauses on hover (pauseAutoPlayOnHover, default on)
      // and setupA11yAutoplay() below adds pause-on-keyboard-focus plus a
      // visible Pause/Play button and honors prefers-reduced-motion.
      autoPlay: this.image_slideshow_speed * 1000,
      pauseAutoPlayOnHover: true,
      arrowShape: arrowShape
    });

    // Resize flickity when the slider is settled
    $slideshowClassicEl.on( 'settle.flickity', function() {
      $slideshowClassicEl.flickity('resize');
    })

    if (this.number_of_slides > 1 && this.image_slideshow_speed > 0) {
      Shopify.theme.jsSlideshowClassic.setupA11yAutoplay($slideshowClassicEl);
    }

  },
  // ADA (WCAG 2.2.2): make an auto-rotating Flickity slideshow pausable.
  // Pauses while any control inside it has keyboard focus, and adds a visible
  // Pause/Play toggle that any user (mouse, keyboard, screen reader) can operate.
  setupA11yAutoplay: function($el) {
    var flkty = $el.data('flickity');
    if (!flkty || $el.data('a11yAutoplay')) return;
    $el.data('a11yAutoplay', true);

    var userPaused = false;

    var $btn = $(
      '<button type="button" class="slideshow-a11y-toggle" data-state="playing" aria-label="Pause slideshow">' +
      '<span class="slideshow-a11y-toggle__icon" aria-hidden="true"></span></button>'
    );
    $el.append($btn);

    function play() {
      flkty.playPlayer();
      $btn.attr({ 'data-state': 'playing', 'aria-label': 'Pause slideshow' });
    }
    function stop() {
      flkty.stopPlayer();
      $btn.attr({ 'data-state': 'paused', 'aria-label': 'Play slideshow' });
    }

    $btn.on('click', function () {
      if ($btn.attr('data-state') === 'playing') { userPaused = true; stop(); }
      else { userPaused = false; play(); }
    });

    // Pause on keyboard focus entering the slideshow; resume when focus leaves
    // (unless the user explicitly paused with the button).
    $el.on('focusin', function () { if (!userPaused) flkty.pausePlayer(); });
    $el.on('focusout', function (e) {
      if (!userPaused && !$.contains($el[0], e.relatedTarget)) flkty.unpausePlayer();
    });

    // Respect users who ask for reduced motion: start paused. Autoplay runs on
    // both desktop and mobile; a small, subtle pause button is shown on mobile
    // (styled in custom-ada-style.css) so touch users still have a pause control
    // (WCAG 2.2.2).
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      userPaused = true;
      stop();
    }
  },
  blockSelect: function($section, blockId) {
    const $slider = $section.find('[data-image-slideshow]');
    const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

    $slider.flickity('select', $sliderIndex, true, true);

  },
	unload: function($section) {

	}
}

/******/ })()
;